module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="base-league-data" >\n	<div class="table-item type std-item">\n		<p>OPEN</p>\n	</div>\n	<div class="table-item avatar">\n		<picture>\n			<source srcset="'+
((__t=( avatar ))==null?'':_.escape(__t))+
'" class="js-display-img" type="image/png">\n			<img src="/assets/images/test-avatar.png?v=1" alt="League avatar">\n		</picture>\n	</div>\n	<div class="table-item name">\n		<div class="league-name">\n			<a href="/fantasy/league/'+
((__t=( id ))==null?'':_.escape(__t))+
'/ladder">'+
((__t=( name ))==null?'':_.escape(__t))+
'</a>\n		</div>\n		';
 if(status === "scheduled") { 
__p+='\n			<p>\n				';
 if( is_commissioner ) { 
__p+='\n					<a href="/fantasy/league/'+
((__t=( id ))==null?'':_.escape(__t))+
'/manage">Manage</a>\n				';
 } 
__p+='\n\n				';
 if( if_settings_access && is_commissioner ) { 
__p+='\n					<span>|</span>\n				';
 } 
__p+='\n\n				';
 if( if_settings_access) { 
__p+='\n					<a href="/fantasy/league/'+
((__t=( id ))==null?'':_.escape(__t))+
'/manage/invites">Invites</a>\n				';
 } 
__p+='\n			</p>\n		';
 } 
__p+='\n		';
 if(winner) { 
__p+='\n			<p class="winner">Winner: '+
((__t=( winner.firstname ))==null?'':_.escape(__t))+
' '+
((__t=( winner.lastname ))==null?'':_.escape(__t))+
'</p>\n		';
 } 
__p+='\n	</div>\n	<div class="table-item size">\n		';
 if(status === "scheduled") { 
__p+='\n			'+
((__t=( num_teams ))==null?'':_.escape(__t))+
'\n			<p class="start-round">Starts R'+
((__t=( start_round ))==null?'':_.escape(__t))+
'</p>\n		';
 }else { 
__p+='\n			'+
((__t=( _.ordinalSuffixOf( rank ) ))==null?'':_.escape(__t))+
'\n		';
 } 
__p+='\n	</div>\n	<div class="table-item arrow">\n		<a href="/fantasy/league/'+
((__t=( id ))==null?'':_.escape(__t))+
'/ladder"></a>\n	</div>\n</div>\n\n\n';
}
return __p;
};
